export { default } from './DocumentSearchInput';